function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.125,
  cy: 9.58972,
  r: 9,
  fill: "#E51212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.59755 6.17707C5.89559 5.89394 6.3788 5.89394 6.67684 6.17707L9.18988 8.56447L11.7029 6.17707C12.0009 5.89394 12.4842 5.89394 12.7822 6.17707C13.0802 6.46021 13.0802 6.91926 12.7822 7.2024L10.2692 9.58978L12.7822 11.9772C13.0802 12.2603 13.0802 12.7194 12.7822 13.0025C12.4842 13.2856 12.0009 13.2856 11.7029 13.0025L9.18988 10.6151L6.67684 13.0025C6.3788 13.2856 5.89559 13.2856 5.59755 13.0025C5.29952 12.7194 5.29952 12.2603 5.59755 11.9772L8.1106 9.58978L5.59755 7.2024C5.29952 6.91926 5.29952 6.46021 5.59755 6.17707Z",
  fill: "white"
});

var SvgWaived = function SvgWaived(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaived, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waived.08d791a0.svg";
export { ForwardRef as ReactComponent };